var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGec3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.41653C0.5 1.80578 1.80578 0.5 3.41653 0.5H26.7488C28.3595 0.5 29.6653 1.80569 29.6653 3.41638L29.6667 11.1962L28.11 10.0268C26.6477 8.92811 24.8313 8.27742 22.8601 8.27742C18.0278 8.27742 14.1105 12.1947 14.1105 17.027C14.1105 18.9982 14.7612 20.8146 15.8599 22.277L16.0548 22.5365V29.6653H3.41653C1.80578 29.6653 0.5 28.3595 0.5 26.7488V3.41653ZM16.0548 10.2218H6.33306V8.27742H16.0548V10.2218ZM6.33306 16.0548H12.1661V14.1105H6.33306V16.0548Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8602 10.2217C19.1016 10.2217 16.0547 13.2686 16.0547 17.0272C16.0547 18.8816 16.7963 20.5626 17.9991 21.7902V28.6939C17.9991 29.0622 18.2072 29.3988 18.5366 29.5635C18.8659 29.7282 19.2601 29.6926 19.5547 29.4717L22.8602 26.9925L26.1658 29.4717C26.4604 29.6926 26.8545 29.7282 27.1839 29.5635C27.5133 29.3988 27.7214 29.0622 27.7214 28.6939V21.7902C28.9242 20.5626 29.6658 18.8816 29.6658 17.0272C29.6658 13.2686 26.6189 10.2217 22.8602 10.2217ZM19.9436 26.7495V23.1779C20.8275 23.5979 21.8165 23.8328 22.8602 23.8328C23.904 23.8328 24.893 23.5979 25.7769 23.1779V26.7495L23.4436 24.9995C23.0979 24.7403 22.6226 24.7403 22.2769 24.9995L19.9436 26.7495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGec3);
export default __webpack_public_path__ + "static/media/gec3.61c21e91c9a856e303d7b8b4e0640850.svg";
export { ForwardRef as ReactComponent };